import * as React from 'react';
import * as JsxRuntime from 'react/jsx-runtime';
import { REPORT_HOST_GLOBAL, REPORT_HOST_MODULES, REPORT_SDK_MODULE, ReportHost } from '@/reports/bundles/types';
import * as Sdk from './sdk';

const MODULES: Record<string, unknown> = {
  react: React,
  'react/jsx-runtime': JsxRuntime,
  [REPORT_SDK_MODULE]: Sdk,
};

/**
 * Install the host a compiled report bundle loads its imports from: the app's
 * own React (so hooks and context work across the boundary) and the SDK.
 * Idempotent; the loader calls it before evaluating any bundle.
 */
export function installReportHost(): ReportHost {
  const host: ReportHost = {
    require: (name) => {
      if (!REPORT_HOST_MODULES.includes(name) || !(name in MODULES)) {
        throw new Error(`Report bundles cannot import "${name}"; only ${REPORT_HOST_MODULES.join(', ')} are available`);
      }
      return MODULES[name];
    },
  };
  (globalThis as unknown as Record<string, unknown>)[REPORT_HOST_GLOBAL] = host;
  return host;
}
